import { Button, Card, Col, Image, Radio, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { InfoIconOutlined } from "../../../../../atoms/CustomIcons";

const { Meta } = Card;

interface PropsType {
  setCurrent: (current: number) => void;
  setType: React.Dispatch<React.SetStateAction<null>>;
  companyId: string;
  type: null | string;
  serviceLineId: string;
}

export default function AddServiceStep1(props: PropsType) {
  const { setCurrent, companyId, setType, type, serviceLineId } = props;

  const navigate = useNavigate();

  return (
    <>
      <Col style={{ width: "672px", paddingBottom: 85 }}>
        <div className="title">
          <h3 style={{ marginBottom: 8 }}>Choose a service structure</h3>
          <p>See which one fits the most.</p>
        </div>

        <div className="service_structure_card">
          <Radio.Group onChange={(e) => setType(e.target.value)} value={type}>
            <Radio.Button value="simple">
              <Card
                cover={
                  <div className="select_service_card">
                    <Image
                      alt="service"
                      preview={false}
                      src="/images/services/simple-service.svg"
                    />
                  </div>
                }
              >
                <Meta
                  title="Simple service"
                  description="For work orders where the tasks and to-dos are always the same, with no variations."
                />
                <Tooltip arrow={false} placement="topLeft" title="Creates">
                  <Button type="text" className="info_btn outlined-btn">
                    <InfoIconOutlined />
                  </Button>
                </Tooltip>
              </Card>
            </Radio.Button>
            <Radio.Button value="subservice">
              <Card
                cover={
                  <div className="select_service_card">
                    <Image
                      alt="service"
                      preview={false}
                      src="/images/services/service-group.svg"
                    />
                  </div>
                }
              >
                <Meta
                  title="Service with subservices"
                  description="For work orders that include different sub-items or variations, depending on the property’s specific needs."
                />
                <Tooltip arrow={false} placement="topLeft" title="Creates">
                  <Button type="text" className="info_btn outlined-btn">
                    <InfoIconOutlined />
                  </Button>
                </Tooltip>
              </Card>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Col>
      <div className="fixed_btm_card">
        <Card>
          <div className="centered">
            <Button
              htmlType="button"
              className="outlined-btn"
              onClick={() =>
                navigate(
                  `/company-settings/service-lines/${serviceLineId}/${companyId}`
                )
              }
            >
              Cancel
            </Button>
            <div style={{ display: "flex", gap: "16px" }}>
              <Button
                htmlType="submit"
                type="primary"
                className="mint-btn"
                onClick={() => setCurrent(1)}
                disabled={!type}
              >
                Continue
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
